import React from 'react';
import { connect } from 'react-redux';
import { ILocalization } from '../../../localization/definitions/types';
import { RootState } from '../../../store';
import './HelpDocumentItem.css';
import { HelpDocumentDownloadIcon } from '../../shared/icons/icons';
import { downloadFile } from '../../../services/downloadFile';
import { generateAdminDocumentUrl } from '../../../utils/generateUrl';
import { IAdminDocument } from '../../admin/supervisors/interfaces';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface HelpDocumentsItemProp {
    localization: ILocalization;
    adminDocument: IAdminDocument;
}

class HelpDocumentItem extends React.Component<HelpDocumentsItemProp> {
    render = () => {
        return (
            <div className='help-document-item'>
                <OverlayTrigger
                    placement='top'
                    overlay={
                        <Tooltip id='button-tooltip-3'>
                            {this.props.adminDocument.description}
                        </Tooltip>
                    }
                >
                    <a
                        href='#/'
                        onClick={() =>
                            downloadFile(
                                generateAdminDocumentUrl(
                                    this.props.adminDocument._id
                                ),
                                this.props.adminDocument.document
                                    ?.originalname ?? ''
                            )
                        }
                    >
                        <div className='d-flex help-document-item-content-wrapper'>
                            <div className='help-document-item-content-download'>
                                <HelpDocumentDownloadIcon />
                                <span className='help-document-item-download-label'>
                                    {`${this.props.localization.localizationStrings.susy.help.helpDocumentsList.labelDownload} / `}
                                </span>
                            </div>

                            <div>
                                <span className='help-document-file'>
                                    {this.props.adminDocument.name}
                                </span>
                            </div>
                        </div>
                    </a>
                </OverlayTrigger>
            </div>
        );
    };
}

const mapStateToProps = (state: RootState) => ({
    localization: state.localization,
});

export default connect(mapStateToProps, {})(HelpDocumentItem);
